@if (enabled()) {
  <div
    class="label"
    routerLinkActive="activeLink"
    verticalPos
    [class.activeChild]="activeChild()"
    [class.warn]="warn()"
    [class.expanded]="!expanded()">
    @if (path() && !submenu.children.length) {
      <a class="wrapper" draggable="false" [routerLink]="path()" (click)="deactivate()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </a>
    } @else {
      <div (click)="toggleActivated($event)" class="wrapper">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    }
  </div>

  <div class="submenu" #submenu [class.activated]="classActivated()">
    <ng-content></ng-content>
  </div>

  <ng-template #content>
    <div class="menu-icon">
      @if (icon(); as icon) {
        <svg-icon [icon]="'icon_' + icon"></svg-icon>
      }
    </div>
    <div class="text-label">
      {{ internalLabel() }}
    </div>
    @if (submenu.children.length) {
      <svg-icon icon="icon_arrow_right" class="expander" />
    }
  </ng-template>
}
